// src/components/common/Card.js
import React from 'react';

const Card = ({
  children,
  className = '',
  hoverable = false,
  bordered = false,
  shadow = 'md',
  padding = 'md',
  onClick,
  ...props
}) => {
  // Determine shadow classes
  const getShadowClasses = () => {
    switch (shadow) {
      case 'none':
        return '';
      case 'sm':
        return 'shadow-sm';
      case 'lg':
        return 'shadow-lg';
      case 'xl':
        return 'shadow-xl';
      case 'md':
      default:
        return 'shadow-md';
    }
  };
  
  // Determine padding classes
  const getPaddingClasses = () => {
    switch (padding) {
      case 'none':
        return 'p-0';
      case 'sm':
        return 'p-3';
      case 'lg':
        return 'p-8';
      case 'xl':
        return 'p-10';
      case 'md':
      default:
        return 'p-6';
    }
  };
  
  // Combine all classes
  const cardClasses = `
    bg-white rounded-lg overflow-hidden
    ${getShadowClasses()}
    ${getPaddingClasses()}
    ${bordered ? 'border border-gray-200' : ''}
    ${hoverable ? 'transition-shadow duration-300 hover:shadow-lg' : ''}
    ${onClick ? 'cursor-pointer' : ''}
    ${className}
  `;
  
  return (
    <div className={cardClasses} onClick={onClick} {...props}>
      {children}
    </div>
  );
};

export default Card;